import React from "react";

const NotFound = () => (
  <div className="min-h-screen flex flex-col items-center justify-center bg-[#0b0b0d] text-white px-6 text-center">
    <img
      src="/assets/echojham.logo.png"
      alt="Echo Jham"
      className="h-14 w-auto object-contain mb-8"
    />
    <p className="text-sm font-semibold tracking-[0.2em] text-white/50">404</p>
    <h1 className="mt-2 text-2xl md:text-3xl font-black uppercase tracking-tight">
      Page not found
    </h1>
    <p className="mt-3 max-w-md text-sm text-white/75 leading-relaxed">
      This page does not exist.
    </p>
  </div>
);

export default NotFound;
